export default "__VITE_ASSET__BWkb9NTN__"